import { extend } from 'vee-validate';

extend('min', {
    validate(value, { min }: any) {
        return value.length >= min;
    },
    params: ['min'],
    message: 'The {_field_} field must be at least {min} characters'
});
